import Vue from "vue";
import axios from "@/api/axios";
import { Component } from "vue-property-decorator";
import { ServiceDefaultNameInterface } from "@/api/Interfaces/ServiceDefaultNameInterface";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const ClinicResultHeaderProps = Vue.extend({
  props: {
    ServiceDefaultName: {
      type: [Object as () => ServiceDefaultNameInterface],
      default: null,
    },
    locationInfo: {
      type: String,
      default: "José Osires Baglioli, Curitiba/Paraná",
    },
    selectedSort: {
      type: String,
      default: "Ordenar por",
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
});

@Component({
  name: "ClinicResultHeader",
  components: {
    "v-select": vSelect,
  },
})
export default class ClinicResultHeader extends ClinicResultHeaderProps {
  cx_ServiceDefaultName = this.ServiceDefaultName;
  cx_locationInfo = this.locationInfo;
  cx_selectedSort = this.selectedSort;
  textFilter = "";
  sortOptions = [
    { label: "Menor distância", value: "distance ASC" },
    { label: "Maior distância", value: "distance DESC" },
    { label: "Menor valor", value: "price ASC" },
    { label: "Maior valor", value: "price DESC" },
    { label: "Melhor avaliação", value: "clinic_rating DESC" },
  ];

  mounted() {
    this.changeFilter();
  }

  /**
   * -----------------------------------------
   * EVENTS
   * -----------------------------------------
   */
  changeFilter(): void {
    switch (this.cx_selectedSort) {
      case "distance ASC":
        this.textFilter = "Menor distância";
        break;
      case "distance DESC":
        this.textFilter = "Maior distância";
        break;
      case "price ASC":
        this.textFilter = "Menor preço";
        break;
      case "price DESC":
        this.textFilter = "Maior preço";
        break;
    }
  }
}
